// JS
import '../../custom/js/custom/index';

// JS Components
import '../../custom/js/custom/pagebuilder';
import '../../custom/js/custom/components/modal';

// Base SCSS
import '../../custom/scss/common/base.scss';
import '../../custom/scss/custom/layout.scss';

// Components SCSS
import '../../custom/scss/custom/page-builder.scss';
import '../../custom/scss/custom/components/home/training.scss';